/**
 * groupr.ts - Groupr (User & Group Management) preferences module
 * 
 * CHANGE HISTORY:
 * - 251031_1600 [pending] danielbeer: Initial creation
 */

export const grouprModule = {
  id: 'business-groupr',
  name: 'User & Group Management',
  icon: '👥',
  category: 'modules',
  order: 51,
  
  packageInfo: {
    name: '@opcentral/groupr',
    version: '0.2.0',
    displayVersion: '0.2.0',
    description: 'Production-ready multi-tenant user, role, and group management for OpCentral',
    status: 'in-progress',
    implementationProgress: 80,
    dependencies: {
      '@opcentral/core': '*',
      '@opcentral/actr': '*',
      '@opcentral/authr': '*'
    },
    keywords: ['users', 'groups', 'roles', 'permissions', 'multi-tenant'],
    author: 'OpCentral Team',
    license: 'MIT'
  },
  
  settings: {
    enableGroupHierarchy: {
      type: 'boolean',
      label: 'Enable Group Hierarchy',
      description: 'Allow nested groups',
      defaultValue: true
    },
    
    inheritPermissions: {
      type: 'boolean',
      label: 'Inherit Permissions',
      description: 'Child groups inherit parent permissions',
      defaultValue: true,
      visible: (settings) => settings['business-groupr.enableGroupHierarchy']
    },
    
    maxGroupDepth: {
      type: 'number',
      label: 'Max Group Depth',
      description: 'Maximum nesting level for groups',
      defaultValue: 5,
      min: 1,
      max: 10,
      visible: (settings) => settings['business-groupr.enableGroupHierarchy']
    }
  }
};

export default grouprModule;
